import { AxiosInstance } from 'axios';
import { AppEntitlementEnum, DataFetcherFunction} from '@/compiler/types';
import baseAxios, { fetchPaginatedDataFunction } from '@/helpers/forms/axios';

export interface addEntitlementFormInterface {
    serviceProviderId: number
    entitlement: AppEntitlementEnum
}

export interface deleteEntitlementFormInterface {
    serviceProviderId: number
    entitlement: AppEntitlementEnum
}

export interface serviceProvidersResponseInterface {
    id: number
    uuid: string
    name: string
    entitlements: AppEntitlementEnum[]
}

export default (axios: AxiosInstance = baseAxios): { searchServiceProviders: DataFetcherFunction<serviceProvidersResponseInterface>; addEntitlement: (form: addEntitlementFormInterface) => Promise<{ message: string; }>; deleteEntitlement: (data: deleteEntitlementFormInterface) => Promise<{ message: string; }>; } => ({
    searchServiceProviders: fetchPaginatedDataFunction<serviceProvidersResponseInterface>(
        '/api/admin/serviceProviderEntitlements/serviceProviders',
        undefined,
        axios,
    ),

    addEntitlement: async (form: addEntitlementFormInterface): Promise<{ message: string }> => {
        const response = await axios.post<{ message: string }>('/api/admin/serviceProviderEntitlements/addEntitlement', { serviceProviderId: form.serviceProviderId, entitlement: form.entitlement });
        return response.data;
    },

    deleteEntitlement: async (data: deleteEntitlementFormInterface): Promise<{ message: string }> => {
        const response = await axios.delete<{ message: string }>('/api/admin/serviceProviderEntitlements/deleteEntitlement', { data });
        return response.data;
    },
});
